<bringoz-icon *ngIf="checkTimeZoneOffsetDiff()" iconName="time-zone" [ngbTooltip]="etaTooltip" openDelay="300" triggers="hover"></bringoz-icon>

<ng-template #etaTooltip>
  <div>
    <span class="br-body-2 margin-right-5">{{{eta: eta} | bringozDate: 'eta': true: timeZoneId}}</span>
    <span>| {{timeZoneId}} ({{timeZoneOffsetDiff}}{{ 'hrs' | translate}})</span>
  </div>
</ng-template>
